export default __webpack_public_path__ + "static/media/logo1.c281bd9e.png";